import React from 'react'

function AcceptRegulations() {
  return (
    <>
    <div className="agree">
        <label>
            <input type="checkbox" name="regulamin" required="" id="id_regulamin"/>
            Potwierdzam, że zapoznałem się i akceptuję&nbsp;  
            <a href="/regulamin/">Regulamin</a>
        </label>
    </div>
    <div className="agree">
        <label>
            <input type="checkbox" name="consent" required="" id="id_consent"/>
            Oświadczam, że wyrażam zgodę na przetwarzanie przekazywanych moich danych osobowych.&nbsp; 
            <a href="/dane-osobowe/">Jak przetwarzamy Twoje dane osobowe</a>
        </label>
    </div>
    </>
  )
}

export default AcceptRegulations